import {ReportData} from "../../../reports/report.data";
import {collection, EntityData, field} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";
import {EmployeeReportSelectionData} from "../../../employee/employee/controls/employee-report-selection-control.component";
import {SupplierReportSelectionData} from "../../supplier/controls/supplier-report-selection-control.component";

export class StockTakeExportReportData extends ReportData<StockTakeExportReportData> {
    @field stockTakeId: number;
}
